import React from 'react';
import {
  DisputeApprovalDrawerBody,
  DisputeEditDrawerBody,
  DisputeRedirectDrawerBody,
  DisputeRejectionDrawerBody,
  DisputeReopenDrawerBody,
  DisputeReviewDrawerBody,
} from '@pay-bill/components';
import {
  DisputeAvailableActionType,
  DisputeReviewFragmentType as DisputeType,
} from '@pay-bill/graphql';

import { StandardNoAccessErrorMessage } from '@common/components';
import { useNavigate } from '@common/hooks';

export const DisputeViewDrawerBody: React.FC<{
  dispute: DisputeType;
  action?: DisputeAvailableActionType;
  onClose: () => void;
}> = ({ dispute, action, onClose }) => {
  const navigate = useNavigate();

  if (action === 'reopen' && dispute.canReopen.value) {
    return (
      <DisputeReopenDrawerBody dispute={dispute} goBack={() => navigate(-1)} />
    );
  }

  if (action === 'edit' && dispute.canEdit.value) {
    return (
      <DisputeEditDrawerBody dispute={dispute} goBack={() => navigate(-1)} />
    );
  }

  if (action === 'approve' && dispute.canApprove.value) {
    return (
      <DisputeApprovalDrawerBody
        dispute={dispute}
        goBack={() => navigate(-1)}
      />
    );
  }

  if (action === 'accept' && dispute.canAccept.value) {
    return (
      <DisputeApprovalDrawerBody
        dispute={dispute}
        goBack={() => navigate(-1)}
      />
    );
  }

  if (action === 'reject' && dispute.canReject.value) {
    return (
      <DisputeRejectionDrawerBody
        dispute={dispute}
        goBack={() => navigate(-1)}
      />
    );
  }

  if (action === 'redirect' && dispute.canEdit.value) {
    return (
      <DisputeRedirectDrawerBody
        dispute={dispute}
        goBack={() => navigate(-1)}
      />
    );
  }

  if (action === 'review') {
    return <DisputeReviewDrawerBody dispute={dispute} onClose={onClose} />;
  }

  return <StandardNoAccessErrorMessage />;
};
